import BigCalendar from './BigCalendar';

export default BigCalendar;
